export function sortFields(relevantFields) {
  return relevantFields.sort((a, b) => {
    if (a.viewIndex < b.viewIndex) {
      return -1;
    }
    if (a.viewIndex > b.viewIndex) {
      return 1;
    }
    return 0;
  });
}

const fieldsType = {
  email: "email",
  mobile: "number",
};

const mapCustomerInformationFields = (relevantFields, userValues) => {
  const orderedFields = [...sortFields(relevantFields)];

  return orderedFields.map((field) => {
    // Update options for those fields, which are not updated by backend
    if (
      userValues &&
      field.options &&
      field.infoFieldName !== "country" &&
      field.infoFieldName !== "type" &&
      field.infoFieldName !== "mobileCode" &&
      field.infoFieldName !== "citizenship"
    ) {
      field.options.forEach((option) => {
        if (
          userValues[field.infoFieldName] &&
          userValues[field.infoFieldName] === option.value
        ) {
          option.selected = true;
        } else {
          option.selected = false;
        }
      });
    }

    // If type selected by user is not supported by the backend then overwite it
    if (userValues && field.infoFieldName === "type") {
      // It can happen that backend doesn't return selected: true for any of the option
      // then select the first option by default
      const selectedOpion =
        field.options.find((option) => option.selected) || field.options[0];

      if (selectedOpion.value !== userValues["type"]) {
        selectedOpion.selected = true;
        userValues["type"] = selectedOpion.value;
      }
    }

    return {
      name: field.infoFieldName,
      label: field.label,
      value: (userValues && userValues[field.infoFieldName]) || "",
      placeholder: field.placeholder,
      isRequired: field.viewLevel === "REQUIRED",
      type: fieldsType[field.infoFieldName] || field.fieldType.toLowerCase(),
      options: field.options,
      isRegistrantSpecific: field.isRegistrantSpecific,
    };
  });
};

export default mapCustomerInformationFields;
